import { ReactElement } from 'react';
import { TextField, DatePickerField } from '@ff-it/form';
import { ExpenseTypeField, ExpenseVATRateField } from 'components';
import { AttachmentField } from 'modules/attachments/AttachmentField';
import { InvoiceFields, CurrencyRateField, TotalsFields } from './Fields';
import { useNumberValidator } from '../useNumberValidator';
import { CompanyField } from 'modules/core/company/components';
import { Sidebar } from 'modules/invoicing/common/Sidebar';

interface FormProps {
  update?: boolean;
  credit?: boolean;
  lockDetails?: boolean;
  bonus: boolean;
}

export function Form({ update, credit, lockDetails, bonus }: FormProps): ReactElement {
  const validateNumberUnique = useNumberValidator();
  return (
    <div className="d-flex flex-column flex-xl-row">
      <div className="container px-0 ml-0">
        <div className="form-row">
          <ExpenseTypeField name="type" label="Type" className="col-md-2" required disabled={update || credit} />
          <TextField
            name="number"
            label="Number"
            className="col-md-3"
            required
            validate={validateNumberUnique}
            disabled={lockDetails}
          />
          <CompanyField
            name="partner"
            label="Provider"
            className="col-md-3"
            required
            disabled={credit || lockDetails}
            includeBranches={true}
          />
          <DatePickerField
            name="checkout_date"
            label="Invoice date"
            className="col-md-2"
            required
            disabled={lockDetails}
          />
          <DatePickerField
            name="payment_date"
            label="Payment date"
            className="col-md-2"
            required
            disabled={lockDetails}
          />
        </div>
        <div className="row">
          <div className="col-6">
            <TextField name="comment" label="Comment" multiline rows={2} />
            <div className="form-row">
              <CurrencyRateField className="col-md-6" disabled={lockDetails} />
              <ExpenseVATRateField
                name="vat_rate"
                label="VAT rate"
                className="col-md-6"
                required
                disabled={lockDetails}
              />
            </div>
            <TotalsFields disabled={lockDetails} />
            <div className="form-row">
              <AttachmentField name="attachments" label="Attachments" className="col-md-12" required />
            </div>
          </div>
          <div className="col-6">
            <InvoiceFields bonus={bonus} />
          </div>
        </div>
      </div>
      {update && <Sidebar />}
    </div>
  );
}
